import React, { Component } from 'react';
import {
  Icon,
  Popup,
  Table,
  Grid,
  Button,
  ButtonGroup,
  Dropdown,
  Accordion,
  Card,
  List,
} from 'semantic-ui-react';
import _ from 'lodash';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import moment from 'moment';
import Papa from 'papaparse';
import { withRouter } from 'react-router';

import hasRESTClient from '../../hocs/has-rest-client';
import hasUserInfo from '../../hocs/has-user-info';
import TryAgainView from '../../components/try-again-view';
import MailoutInfluencerTableRow from '../../components/mailout-influencer-table-row';
import InfluencerTableLoadingRow from '../../components/influencer-table-loading-row';
import MailoutsCreateModal from '../../components/mailouts-create-modal';
import MailoutTestModal from '../../components/mailout-test-modal';
import MailoutSendModal from '../../components/mailout-send-modal';
import * as countryList from '../../utils/helpers/countries';
import ConfirmationModal from '../../components/confirmation-modal';

const buttonHeight = { height: '40px' };
const btnStyles = { height: '40px', border: 'none', width: '80%' };
const menuOptions = [
  { key: 'test', text: 'Test Mailout', value: 'test', icon: 'send' },
  { key: 'send', text: 'Send Mailout', value: 'send', icon: 'mail' },
  { key: 'delete', text: 'Delete Mailout', value: 'delete', icon: 'trash' },
];

const menuGroupStyles = {
  color: '#1d1937',
  border: '2px solid #1d1937',
  fontWeight: 600,
  width: '100%',
};
const dropdownStyles = { display: 'flex', alignItems: 'center' };
const accordionTitleStyle = { color: 'rgba(0,0,0,.4)' };
const accordionContentStyle = { position: 'absolute', zIndex: 999 };
const historyItemStyle = { padding: '10px' };


class Mailouts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      influencers: [],
      title: '',
      isLoading: false,
      error: null,
    };
    const { buildRESTClient } = this.props;
    this.emailProcessor = buildRESTClient({
      baseURL: process.env.REACT_APP_EMAIL_PROCESSOR_URL || '',
      hasToken: false,
      timeout: 100000,
    });
  }

  fetchInfluencers() {
    this.setState({ isLoading: true });

    const { restClient, routeParams, id } = this.props;
    const urlId = _.get(routeParams, 'id', id);

    restClient.get(`/mailouts/${urlId}`).then(response => {
      const { data: { data: { attributes: { influencers, name, createdDate, outreachEmailSubject,
        outreachEmailTemplate, lastSentDate, outreachHistory, utmSource }, relationships } } } = response;
      const campaignId = _.get(relationships, 'campaign.data.id');
      this.setState({
        isLoading: false,
        influencers,
        createdDate,
        title: name,
        campaignId,
        lastSentDate,
        outreachHistory,
        mailout: {
          id: urlId,
          mailoutName: name,
          outreachEmailTemplate,
          outreachEmailSubject,
          lastSentDate,
          outreachHistory,
          utmSource,
          totalInfluencers: _.size(influencers),
        },
        error: null,
      });
    }).catch(err => {
      this.setState({ isLoading: false, error: err });
    });
  }

  submitMailout = async payload => {
    const { restClient, campaign, userInfo, routeParams, id } = this.props;
    const urlId = _.get(routeParams, 'id', id);

    this.setState({ isSubmitting: true });
    const { mailoutName: name, outreachEmailTemplate, outreachEmailSubject, utmSource } = payload;

    const mailout = {
      data: {
        attributes: {
          name,
          outreachEmailTemplate,
          outreachEmailSubject,
          utmSource,
        },
      },
    };
    const patchResponse = await restClient.patch(`/mailouts/${urlId}`, mailout).catch(err => {
      console.log('Error updating mailout: ', err);
      this.setState({ isSubmitting: false, submitError: true });
    });
    this.setState(prev => ({
      isSubmitting: false,
      submitError: !patchResponse,
      modalOpened: patchResponse ? false : prev.modalOpened,
    }));
    this.fetchInfluencers();
  }

  submitTestMailout = async payload => {
    const { routeParams } = this.props;
    const { campaignId } = this.state;
    const urlId = _.get(routeParams, 'id');
    const { email, name } = payload;

    const domain = window.location.origin;
    const request = {
      email, name, campaignId, mailoutId: urlId, domain,
    };
    this.setState({ isSubmittingTestMailout: true });
    const testResponse = await this.emailProcessor.post('/mailouts/test', request)
      .then(({ data }) => data)
      .catch(e => {
        this.setState({ submitTestMailoutError: 'Something went wrong. Pleas try again later', isSubmittingTestMailout: false });
      });

    const isSentSuccessfully = _.get(testResponse, '[0].status') === 'sent';
    if (isSentSuccessfully) {
      this.setState({
        isSubmittingTestMailout: false,
        mailoutTestSuccess: true,
        submitTestMailoutError: null,
      });
    } else {
      this.setState({
        isSubmittingTestMailout: false,
        mailoutTestSuccess: false,
        submitTestMailoutError: _.get(testResponse, 'data.message', 'Something went wrong. Pleas try again later'),
      });
    }
    this.fetchInfluencers();
  }


  submitSendMailout = async () => {
    const { routeParams } = this.props;
    const { campaignId } = this.state;
    const urlId = _.get(routeParams, 'id');
    const { email: testEmail, name: testName } = _.get(this.props, 'userInfo', {});
    const domain = window.location.origin;
    const request = {
      campaignId,
      mailoutId: urlId,
      testEmail,
      testName,
      domain,
    };

    this.setState({ isSendingMailout: true });
    const response = await this.emailProcessor.post('/mailouts/send', request)
      .then(({ data }) => data)
      .catch(e => {
        this.setState({
          isSendingMailout: false,
          mailoutSendModalOpened: false,
        });
      });

    const isSentSuccessfully = _.get(response, 'statusCode') === 200;
    if (isSentSuccessfully) {
      const { sentEmails, failedEmails } = _.get(response, 'data', {});
      this.setState({
        isSendingMailout: false,
        sendMailoutError: null,
        mailoutSuccessMessage: `Mailout sent successfully. Sent emails: ${_.size(sentEmails)}. Failed emails: ${_.size(failedEmails)}`,
      });
    } else {
      const errorMessage = _.get(response, 'data.message', null);
      this.setState(prev => ({
        isSendingMailout: false,
        sendMailoutError: errorMessage,
        mailoutSuccessMessage: null,
        mailoutSendModalOpened: errorMessage ? prev.mailoutSendModalOpened : false,
      }));
    }
    this.fetchInfluencers();
  }

  toggleDeleteConfirmModal = influencerId => {
    this.setState(prev => ({
      confirmModalOpened: !prev.confirmModalOpened,
      influencerToDelete: !prev.confirmModalOpened ? influencerId : null,
    }));
  }

  deleteMailout = async () => {
    this.toggleMailoutDeleteConfirmation();
    this.setState({ isDeletingMailout: true });
    const { restClient, routeParams, id, router } = this.props;
    const urlId = _.get(routeParams, 'id', id);
    const { campaignId } = this.state;
    if (campaignId) {
      console.log('Campaign Id: ', campaignId);
      await restClient.delete(`/mailouts/${urlId}`).then(res => {
        this.setState({ isDeletingMailout: false });
        // eslint-disable-next-line lodash/prefer-lodash-method
        router.replace(`/campaign/${campaignId}/notifications`);
      }).catch(e => {
        this.setState({ isDeletingMailout: false });
      });
    }
  }
  removeInfluencer = async () => {
    const { deletingId, influencerToDelete } = this.state;
    if (deletingId) {
      return;
    }
    this.setState({
      deletingId: influencerToDelete,
    });
    this.toggleDeleteConfirmModal();
    const { restClient, routeParams, id } = this.props;
    const { influencers } = this.state;

    const urlId = _.get(routeParams, 'id', id);

    const filteredInfluencers = _.reject(influencers, ['instagramId', influencerToDelete]);
    const data = {
      attributes: { influencers: filteredInfluencers },
    };
    await restClient.patch(`/mailouts/${urlId}`, {
      data,
    }).then(() => {
      this.setState({ influencers: filteredInfluencers });
    }).catch(e => {
      console.log('Patch Error: ', e);
    }).finally(() => {
      this.setState({
        deletingId: null,
      });
    });
  }

  componentDidMount() {
    this.fetchInfluencers();
  }

  toggleMailoutTestModal = () => {
    this.setState(prev => ({
      mailoutTestModalOpened: !prev.mailoutTestModalOpened,
      mailoutTestSuccess: !prev.mailoutTestModalOpened ? false : prev.mailoutTestSuccess,
      submitTestMailoutError: !prev.mailoutTestModalOpened ? null : prev.submitTestMailoutError,
    }));
  }
  toggleMailoutSendModal = () => {
    this.setState(prev => ({
      mailoutSendModalOpened: !prev.mailoutSendModalOpened,
      mailoutSuccessMessage: !prev.mailoutSendModalOpened ? false : prev.mailoutSuccessMessage,
      sendMailoutError: !prev.mailoutSendModalOpened ? null : prev.sendMailoutError,
    }));
  }

  toggleMailoutDeleteConfirmation = () => {
    this.setState(prev => ({ confirmDeleteMailoutOpened: !prev.confirmDeleteMailoutOpened }));
  }


  onMenuItemSelect = item => {
    if (item === 'test') {
      this.toggleMailoutTestModal();
    }
    if (item === 'send') {
      this.toggleMailoutSendModal();
    }
    if (item === 'delete') {
      this.toggleMailoutDeleteConfirmation();
    }
  }


  downloadCSV = () => {
    const { influencers, title } = this.state;
    if (_.isEmpty(influencers)) {
      return;
    }
    const csv = Papa.unparse(influencers);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `${title}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  toggleMailoutsModal = () => {
    this.setState(prev => ({
      modalOpened: !prev.modalOpened,
      isSubmitting: !prev.modalOpened ? false : prev.isSubmitting,
      submitError: false,
    }));
  }
  toggleHistory = () => {
    this.setState(prev => ({
      historyOpened: !prev.historyOpened,
    }));
  }
  render() {
    const {
      influencers,
      isLoading,
      error,
      title,
      createdDate,
      modalOpened,
      isSubmitting,
      submitError,
      mailout,
      mailoutTestModalOpened,
      isSubmittingTestMailout,
      submitTestMailoutError,
      mailoutTestSuccess,
      mailoutSendModalOpened,
      isSendingMailout,
      mailoutSuccessMessage,
      sendMailoutError,
      confirmModalOpened,
      lastSentDate,
      outreachHistory,
      historyOpened,
      confirmDeleteMailoutOpened,
    } = this.state;

    const hasOutreachHistory = !_.isEmpty(outreachHistory);
    return (
      <div className="page">
        { modalOpened &&
          <MailoutsCreateModal
            onClose={this.toggleMailoutsModal}
            onSubmit={this.submitMailout}
            isSubmitting={isSubmitting}
            mailout={mailout}
            error={submitError}
          />
        }
        { mailoutTestModalOpened &&
          <MailoutTestModal
            onClose={this.toggleMailoutTestModal}
            onSubmit={this.submitTestMailout}
            isSubmitting={isSubmittingTestMailout}
            mailout={mailout}
            error={submitTestMailoutError}
            mailoutTestSuccess={mailoutTestSuccess}
          />
        }
        { mailoutSendModalOpened &&
          <MailoutSendModal
            onClose={this.toggleMailoutSendModal}
            onSubmit={this.submitSendMailout}
            isSubmitting={isSendingMailout}
            mailout={mailout}
            error={sendMailoutError}
            successMessage={mailoutSuccessMessage}
          />
        }
        { confirmModalOpened && <ConfirmationModal
          headerText="Deleting Influencer"
          bodyText={'Are you sure you want to delete influencer?'}
          onCancel={() => this.toggleDeleteConfirmModal()}
          onConfirm={this.removeInfluencer}
        />}
        { confirmDeleteMailoutOpened && <ConfirmationModal
          headerText="Deleting Mailout"
          bodyText={'Are you sure you want to delete mailout?'}
          onCancel={() => this.toggleMailoutDeleteConfirmation()}
          onConfirm={this.deleteMailout}
        />}
        <div style={{ paddingTop: 40, backgroundColor: '#FFF', borderBottom: '1px solid #EEE' }}>
          <div className="page-hero" style={{ height: 'auto' }}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={11}>
                  <div>
                    <h1>Mailouts</h1>
                    <h3>{title} </h3>
                    {
                      !isLoading && <div style={{ paddingTop: '10px', paddingBottom: '20px' }}>
                        <h4>Total Influencers: {_.size(influencers)}</h4>
                        <h5 style={{ color: 'rgba(0,0,0,.4)' }}>Created: {moment(createdDate).format('YYYY-MM-DD, h:mm')}</h5>
                        {hasOutreachHistory && <Accordion>
                          <Accordion.Title
                            active={historyOpened}
                            index={0}
                            onClick={this.toggleHistory}
                            style={accordionTitleStyle}
                          >
                            {hasOutreachHistory}
                            <span>Last Sent: {moment(lastSentDate).format('YYYY-MM-DD, h:mm')}</span>
                            <Icon name="dropdown" />
                          </Accordion.Title>
                          <Accordion.Content active={historyOpened}>
                            <Card style={accordionContentStyle}>
                              <Card.Content>
                                <List divided verticalAlign="middle">
                                  {_.map(outreachHistory, item => {
                                    const dateString = _.replace(item, 'Mailout sent on ', '');
                                    const date = moment(dateString).format('YYYY-MM-DD, h:mm');
                                    return <List.Item style={historyItemStyle}> Mailout sent on {date}</List.Item>;
                                  })}
                                </List>
                              </Card.Content>
                            </Card>
                          </Accordion.Content>
                        </Accordion>}
                        {!hasOutreachHistory && <h5 style={{ color: 'rgba(0,0,0,.4)' }}>Not sent yet</h5>
                        }
                      </div>
                    }
                  </div>
                </Grid.Column>
                <Grid.Column width={2} textAlign="center">
                  <Button
                    style={buttonHeight}
                    disabled={_.isEmpty(influencers)}
                    onClick={this.downloadCSV}
                    color="pink"
                    icon="download"
                    content="Export as CSV"
                  />
                </Grid.Column>
                <Grid.Column width={3} textAlign="center">
                  <ButtonGroup
                    basic compact style={menuGroupStyles}
                  >
                    <Button style={btnStyles} disabled={isLoading} onClick={this.toggleMailoutsModal} basic icon="edit" content="Edit Mailout" />
                    <Dropdown
                      className="button icon"
                      style={dropdownStyles}
                      options={menuOptions}
                      floating
                      selectOnBlur={false}
                      onChange={(e, data) => {
                        this.onMenuItemSelect(data.value);
                      }}
                      trigger={<div />}
                    />
                  </ButtonGroup>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </div>
        <div className="page-content">
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell />
                <Table.HeaderCell
                  width={10}
                >
                  Influencer
                </Table.HeaderCell>
                <Table.HeaderCell
                  width={3}
                >
                  Email
                </Table.HeaderCell>
                <Table.HeaderCell
                  width={1}
                  textAlign="center"
                >
                  <Popup
                    trigger={<Icon name="flag outline" />}
                    content="Influencer country"
                  />
                </Table.HeaderCell>

                <Table.HeaderCell
                  textAlign="center"
                  width={1}
                >
                  <Popup
                    trigger={<Icon name="percent" color="pink" />}
                    content="Instagram Engagement Rate"
                  />
                </Table.HeaderCell>
                <Table.HeaderCell
                  width={1}
                  textAlign="center"
                >
                  <img src="/icons/instagram.svg" alt="Instagram" />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>

              { isLoading && <InfluencerTableLoadingRow colSpan={11} /> }

              { !isLoading && error &&
              <Table.Row>
                <Table.Cell colSpan={16} height="500" textAlign="center">
                  <TryAgainView
                    onClick={this.fetchInfluencers}
                  />
                </Table.Cell>
              </Table.Row>
              }

              { !isLoading && !error && influencers && _.map(influencers,
                (influencer, index) => (<MailoutInfluencerTableRow
                  key={`${influencer.instagramId}(${index})`}
                  colSpan={12}
                  influencer={influencer}
                  countries={countryList.default}
                  onDelete={influencerId => this.toggleDeleteConfirmModal(influencerId)}
                  isDeleting={influencer.instagramId && influencer.instagramId === this.state.deletingId}
                />))
              }
            </Table.Body>
          </Table>

        </div>
      </div>);
  }
}

export default compose(hasRESTClient, hasUserInfo, withRouter)(Mailouts);

Mailouts.propTypes = {
  restClient: PropTypes.func.isRequired,
  buildRESTClient: PropTypes.func.isRequired,
  routeParams: PropTypes.object,
  id: PropTypes.string,
};
Mailouts.defaultProps = {
  routeParams: null,
  id: null,
};



/** WEBPACK FOOTER **
 ** ./src/containers/mailouts/index.js
 **/